import { ExpressCloud } from '@/models/ExpressCloud'
import { ExpressCloud as ExpressCloudResource } from '@/resources/forge'

const store = {
  namespaced: true,
  state: {
    current: null,
  },
  mutations: {
    /**
     * Sets the current ExpressCloud object in the store state.
     * @param {Object} current - The current ExpressCloud object.
     */
    setCurrent(state, current) {
      state.current = current
    },
    /**
     * Deletes the current ExpressCloud object from the store state.
     * @param {string} id - The ID of the ExpressCloud object to delete.
     */
    delete(state, id) {
      state.current = null
    },
    /**
     * Creates a new ExpressCloud object and sets it as current in the store state.
     * @param {Object} current - The new ExpressCloud object to set as current.
     */
    create(state, current) {
      state.current = current
    },
    /**
     * Updates the current ExpressCloud object in the store state.
     * @param {Object} params - The parameters to update the current ExpressCloud object.
     */
    update(state, params) {
      if (state.current.id != params.current.id) return

      state.current = params.current
    },
  },
  actions: {
    /**
     * Loads a ExpressCloud object from the API and sets it as current in the store state.
     * @param {string} parse_setting_id - The ID of the Parse setting.
     * @returns {Promise} A promise resolving to the API response.
     */
    async load({ commit, dispatch }, parse_setting_id) {
      const res = await ExpressCloudResource.get({
        parse_setting_id: parse_setting_id,
      })
      const expressCloud = new ExpressCloud(res.body.express_codes[0])
      commit('setCurrent', expressCloud)
      if (expressCloud.id != null) {
        dispatch('versions/loadExpress', expressCloud.id, { root: true })
      }
      return res
    },
    /**
     * Updates the ExpressCloud object.
     * @param {Object} params - The parameters for updating the ExpressCloud object.
     * @returns {Promise} A promise resolving to the API response.
     */
    update({ commit, dispatch }, params) {
      return ExpressCloudResource.update(
        { id: params.id },
        { express_code: params.express_code }
      )
        .then((res) => {
          commit('setCurrent', new ExpressCloud(res.body.express_code))
          if (params.express_code.current_version_id == undefined)
            dispatch('versions/addParseVersion', res.body.version, {
              root: true,
            })
        })
        .catch((err) => {
          console.log(err)
        })
    },
  },
  getters: {
    /**
     * Finds a ExpressCloud object by its ID.
     * @param {string} id - The ID of the ExpressCloud object to find.
     * @returns {Object|null} The ExpressCloud object if found, otherwise null.
     */
    findById: (state) => (id) => {
      return state.list.find((v) => v.id == id)
    },
  },
}

export default store
